import React, { MutableRefObject } from 'react';
import { SwipeableHandlers } from 'react-swipeable';
import { Slide } from '@material-ui/core';
import { useSelector } from 'react-redux';

import { Player } from '../../components/index';
import MediaPreviewStyles from './styles';

import { selectCurrentUser } from '../../store/modules/users/selectors';
import { Media } from '../../store/modules/media-viewer/types';

type Props = {
  media: Media;
  swipeable?: SwipeableHandlers;
  slideDirection: 'left' | 'right' | 'up' | 'down';
  isChangePreviewMedia: number | null;
  refPreviewContent: MutableRefObject<HTMLDivElement | null>;
};

const MediaVideo = ({
  media, swipeable, slideDirection, isChangePreviewMedia, refPreviewContent,
}: Props) => {
  const classes = MediaPreviewStyles();
  const { data: currentUser } = useSelector(selectCurrentUser);

  return (
    <Slide
      direction={slideDirection}
      in={isChangePreviewMedia === null}
      mountOnEnter
      unmountOnExit
      timeout={300}
    >
      <div className={classes.playerWrapper}>
        <Player
          src={media.url}
          swipeable={swipeable}
          isStream={true}
          key={media.url}
          refPreviewContent={refPreviewContent}
          videoMeta={{
            viewer_user_id: currentUser?.id || -1,
            video_title: media.title,
            video_id: media.id,
          }}
        />
      </div>
    </Slide>
  );
};

export default MediaVideo;
